import { useState } from "react"
import { PiMagnifyingGlassDuotone } from 'react-icons/pi'
import { FiLoader } from 'react-icons/fi'
import api from '../../../utils/api'
import useFlashMessage from '../../../hooks/useFlashMessage'
import RequiredMark from '../form/RequiredMark'

import './CnpjSearchTrigger.css'

// Campo de CNPJ com botão de busca colado — consulta a Receita Federal (via BrasilAPI, no
// backend) e devolve os dados da empresa pro chamador preencher os campos do formulário.
// `value` é o texto exibido (já com máscara); a busca usa só os dígitos.
function CnpjSearchTrigger({ text, name, placeholder, value, handleOnChange, onFound, required }) {
    const [searching, setSearching] = useState(false)
    const { setFlashMessage } = useFlashMessage()

    async function search() {
        const digits = (value || '').replace(/\D/g, '')
        if (digits.length !== 14) {
            setFlashMessage('Digite um CNPJ válido (14 dígitos)', 'error')
            return
        }

        setSearching(true)
        const data = await api.get(`/cnpj/${digits}`)
            .then((response) => response.data)
            .catch((err) => err.response?.data || null)
        setSearching(false)

        if (!data || !data.corporateName) {
            setFlashMessage((data && data.message) || 'CNPJ não encontrado', 'error')
            return
        }

        onFound(data)
    }

    return (
        <div>
            {text && <label htmlFor={name}>{text}:{required && <RequiredMark />}</label>}
            <div className="cnpj-search-group">
                <input
                    className="input cnpj-search-input"
                    type="text"
                    name={name}
                    id={name}
                    placeholder={placeholder}
                    value={value || ''}
                    onChange={handleOnChange}
                />
                <button type="button" className="cnpj-search-btn" title="Buscar dados pelo CNPJ" onClick={search} disabled={searching}>
                    {searching
                        ? <FiLoader size={20} className="cnpj-search-spin" />
                        : <PiMagnifyingGlassDuotone size={23} />
                    }
                </button>
            </div>
        </div>
    )
}

export default CnpjSearchTrigger
